export function truncateString(str, num) {
  if (!str) {
    return str;
  }
  if (str.length <= num) {
    return str;
  }
  return str.slice(0, num) + '...';
}